import angular from "angular";
import component from "./register-requests-control.component";
let mod = angular.module('RegisterRequests', [component]);
export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/register-requests-control/register-requests-control.module.js